import Guid from "_shared/guids/guid";
import TeamProfile from "marketplace/team-profile/team-profile";
import MarketplaceCompanyInfoSchema, { MarketplaceCompanyInfoJSON } from "marketplace/_schema/marketplace-company-info-schema";
import MarketplaceIndividualInfoSchema, { MarketplaceIndividualInfoJSON } from "marketplace/_schema/marketplace-individual-info-schema";
import MarketplaceTeam from "marketplace/teams/team";

export default class MarketplaceTeamInfoAPIResponse {
  id?: string;
  type?: string;
  isVisible?: boolean;
  name?: string;
  description?: string;
  leader?: MarketplaceIndividualInfoJSON;
  members?: MarketplaceIndividualInfoJSON[];
  associatedFirms?: MarketplaceCompanyInfoJSON[];
  categories?: string[];
  avatar?: string;

  constructor(init?: Partial<MarketplaceTeamInfoAPIResponse>) {
    Object.assign(this, init);
  }

  public deserializeToTeam(): MarketplaceTeam {
    const id = Guid.fromJSON(this.id);
    if (!id) {
      throw new Error("Team ID is required, was not returned by the API");
    }
    if (!this.name) {
      throw new Error("Team name is required, was not returned by the API");
    }
    const profile = TeamProfile.fromJSON({
      ...this,
      name: this.name
    });

    const leader = MarketplaceIndividualInfoSchema.deserialize(MarketplaceIndividualInfoSchema.validateJSON(this.leader));
    if (!leader) {
      throw new Error("Team leader is required, was not returned by the API");
    }
      
    return new MarketplaceTeam({
      id,
      leader,
      profile,
      isVisible: this.isVisible ?? false,
      members: (this.members ?? []).map((memberInfo) => {
        const member = MarketplaceIndividualInfoSchema.deserialize(MarketplaceIndividualInfoSchema.validateJSON(memberInfo));
        if (!member)
          throw new Error("Team member could not be deserialized from API response");
        return member;
      }),
      associatedFirms: (this.associatedFirms ?? []).map((companyInfo) => {
        const company = MarketplaceCompanyInfoSchema.deserializeToProfile(MarketplaceCompanyInfoSchema.validateJSON(companyInfo));
        if (!company)
          throw new Error("Associated firm could not be deserialized from API response");
        return company;
      }),
    });
  }
}
